export default __webpack_public_path__ + "static/media/francheville12.5eba60e1.jpg";